import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";

declare const __VERSION__: string;
declare const __GAMENAME__: string;

class TranslationKeyReplacer {

    private options: ControlOptions;

    private stringValueMap: Map<string, () => number | string>;

    public constructor() {
        this.stringValueMap = new Map();
        this.stringValueMap.set("totalstake", () => this.returnTotalStake());
        this.stringValueMap.set("totallines", () => this.returnTotalLines());
        this.stringValueMap.set("totalwin", () => this.returnTotalWin());
        this.stringValueMap.set("version", () => this.returnVersionNumber());
        this.stringValueMap.set("gamename", () => this.returnGameName());

        SmartUIManager.onOptionsChanged.add((options: ControlOptions) => this.updateOptions(options));
    }

    public lookup(toLookup: string) {
        return this.stringValueMap.has(toLookup);
    }

    public get(toGet: string): string | number {
        return this.stringValueMap.get(toGet)();
    }

    private updateOptions(options: ControlOptions) {
        this.options = options;
    }

    private returnTotalStake(): string {
        return Services.currency.format(this.options.getTotalStake());
    }

    private returnTotalLines(): number {
        return this.options.lines.defaultValue;
    }

    private returnTotalWin(): string {
        if (GameState.getCurrentGame().hasRecords()) {
            return Services.currency.format(GameState.getCurrentGame().getTotalWin());
        }
    }

    private returnVersionNumber() {
        return __VERSION__;
    }

    private returnGameName() {
        return __GAMENAME__;
    }
}

export default new TranslationKeyReplacer();
